/*
 * Copyright (c) 2021 - 2026 All rights reserved by Ferenc Farkas <wolferi93@gmail.com>
 */

/**
 * Widget preference + auto-reload constants. Deliberately import-free: `widgetConfig.js` pulls in the app-variant
 * resolver (and through it native modules), while the refresh helpers - which also run in the headless Android widget
 * task and in tests that mock the bridge - only need these plain values. `widgetConfig.js` re-exports all of them.
 */

/** AsyncStorage key persisting the user's in-app widget preferences. */
export const WIDGET_PREFS_KEY = 'HG_WIDGET_PREFS';

/**
 * App Group `UserDefaults` key (iOS) mirroring the chosen auto-reload interval in MINUTES, read by the extension to pick
 * the timeline reload policy (`widgetRefreshInterval()` in `targets/widgets/WidgetTimeline.swift`).
 */
export const WIDGET_REFRESH_MINUTES_KEY = 'HG_WIDGET_REFRESH_MINUTES';

/** Selectable auto-reload intervals (minutes), cycling order of the settings row. */
export const WIDGET_REFRESH_OPTIONS = [5, 15, 30, 60];

/** Default auto-reload interval (minutes) - the pre-setting behaviour of the iOS timelines. */
export const WIDGET_REFRESH_DEFAULT = 15;

/**
 * Clamp an arbitrary value to a supported auto-reload interval.
 * @param {*} value Candidate minutes.
 * @returns {number} One of `WIDGET_REFRESH_OPTIONS` (the default when invalid).
 */
export const normalizeRefreshMinutes = (value) => {
    const minutes = Number(value);

    return WIDGET_REFRESH_OPTIONS.includes(minutes) ? minutes : WIDGET_REFRESH_DEFAULT;
};
